import butterflyLesson from './butterflyLesson/butterflyLesson'
import womenInType from './womenInType/womenInType'
import cerasusName from './cerasusName/cerasusName'
import eflorals from './eflorals/eflorals'

const storyList = [cerasusName, butterflyLesson, womenInType, eflorals]

export default storyList;